import React from "react";

const IconFacebookWhite = () => {
    return (
        <svg
            viewBox="0 0 278 512"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19 297.323H72.7173V495.979C72.7173 504.811 79.864 511.979 88.7173 511.979L174.2 512C183.053 512 190.2 504.811 190.2 496V297.344H241.123C249.187 297.344 255.992 291.328 256.995 283.328L267.619 197.995C268.813 188.48 261.368 180.011 251.747 180.011H190.2C192.611 127.296 180.92 111.701 215.203 111.701C238.413 108.928 275.021 120.683 275.021 95.7013V19.392C275.021 11.392 269.112 4.62933 261.197 3.54133C254.499 2.624 228.024 0 195.192 0C45.6453 0 76.4293 165.803 72.7387 179.989H19C10.168 179.989 3 187.157 3 195.989V281.323C3 290.155 10.168 297.323 19 297.323V297.323ZM35 212.011H88.7173C97.5493 212.011 104.717 204.843 104.717 196.011V128.789C104.717 67.2853 137.677 32.0213 195.171 32.0213C213.901 32.0213 231.139 32.9387 243 33.8773V79.7227C234.424 84.096 158.179 60.864 158.179 137.259V196.032C158.179 204.864 165.347 212.032 174.179 212.032H233.613L226.957 265.365H174.179C165.347 265.365 158.179 272.533 158.179 281.365V480H104.739V281.344C104.739 272.512 97.5707 265.344 88.7387 265.344H35V212.011Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconFacebookWhite;
